import axios from '../../utils/axios2';

export default {
    
    namespaced: true,

    state: {
        jobcardFailure: null,
        jobcardFailures: null
    },

    mutations: {
        setJobcardFailure(state, payload) {
            state.jobcardFailure = payload;
        },
        setJobcardFailures(state, payload) {
            state.jobcardFailures = payload;
        }
    },

    actions: {
        storeJobcardFailure({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `jobcard-failures`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        updateJobcardFailure({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcard-failures/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        fetchJobcardFailures({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-failures?jobcard_id=${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcardFailures', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        fetchJobcardFailure({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-failures/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcardFailure', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        removeJobcardFailure({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `jobcard-failures/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        }
    }
}